import { render, staticRenderFns } from "./c-tree-menu.vue?vue&type=template&id=2b0cc6f6&scoped=true&"
import script from "./c-tree-menu.vue?vue&type=script&lang=js&"
export * from "./c-tree-menu.vue?vue&type=script&lang=js&"
import style0 from "./c-tree-menu.vue?vue&type=style&index=0&id=2b0cc6f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0cc6f6",
  null
  
)

export default component.exports